import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import {
  GeoJSON,
} from 'react-leaflet';
import deepOrange from '@material-ui/core/colors/deepOrange';
import dataJSON from '../../assets/map/geojson/basin.json';

export default function LayerBasin(props) {
  const refBoundaryBasin = useRef();

  const [geojson, setGeojson] = useState(null);

  useEffect(() => {
    setGeojson(dataJSON);
  }, []);

  function getStyle(feature) {
    const {
      areaType, areaId, areaFill,
      areaStroke, areaStrokeColor, areaFillColor,
      areaFillOpacity, areaWeight,
      areaCurrentStroke, areaCurrentStrokeColor, areaCurrentFillColor,
      areaCurrentFillOpacity, areaCurrentWeight,
    } = props;
    if (areaType.toString() === '1' && areaId) {
      if (feature.properties.BASIN_CODE === areaId) {
        return {
          stroke: areaFill ? areaCurrentStroke : true,
          color: areaFill ? areaCurrentStrokeColor : deepOrange[700],
          weight: areaFill ? areaCurrentWeight : 2,
          fillColor: areaFill ? areaCurrentFillColor : deepOrange[700],
          fillOpacity: areaFill ? areaCurrentFillOpacity : 0,
        };
      }
    }

    return {
      stroke: areaFill ? areaStroke : false,
      color: areaFill ? areaStrokeColor : '',
      weight: areaFill ? areaWeight : 2,
      fillColor: areaFill ? areaFillColor : '#FFF',
      fillOpacity: areaFill ? areaFillOpacity : 0,
    };
  }

  return (
    <GeoJSON
      key={uniqueId()}
      data={geojson}
      style={getStyle}
      ref={refBoundaryBasin}
      // onEachFeature={this.onEachBasinFeature}
    />
  );
}

LayerBasin.defaultProps = {
  areaId: '',
  areaFill: false,

  areaStroke: false,
  areaStrokeColor: '',
  areaFillColor: '',
  areaFillOpacity: 1,
  areaWeight: 0,

  areaCurrentStroke: false,
  areaCurrentStrokeColor: '',
  areaCurrentFillColor: '',
  areaCurrentFillOpacity: 0,
  areaCurrentWeight: 0,
};

LayerBasin.propTypes = {
  areaType: PropTypes.number.isRequired,
  areaId: PropTypes.string,
  areaFill: PropTypes.bool,

  areaStroke: PropTypes.bool,
  areaStrokeColor: PropTypes.string,
  areaFillColor: PropTypes.string,
  areaFillOpacity: PropTypes.number,
  areaWeight: PropTypes.number,

  areaCurrentStroke: PropTypes.bool,
  areaCurrentStrokeColor: PropTypes.string,
  areaCurrentFillColor: PropTypes.string,
  areaCurrentFillOpacity: PropTypes.number,
  areaCurrentWeight: PropTypes.number,
};
